export default __webpack_public_path__ + "static/media/objectives_icon_5.8412fee5.png";